import React from 'react';
import { TbCreditCard } from 'react-icons/tb';
import { SiMastercard, SiPaypal, SiSepa } from 'react-icons/si';
import { FaCcAmex, FaCcVisa } from 'react-icons/fa6';
import { PaymentDetails } from '../../../types/payments';

interface PaymentMethodIconProps {
  details: PaymentDetails;
  t: (key: string, opts?: Record<string, unknown>) => string;
}

export default function PaymentMethodIcon({ details, t }: PaymentMethodIconProps) {
  if (details.type === 'card') {
    const icon =
      details.brand === 'visa' ? (
        <FaCcVisa size={32} className="text-primary-300" />
      ) : details.brand === 'mastercard' || details.brand === 'maestro' ? (
        <SiMastercard size={28} className="text-danger" />
      ) : details.brand === 'amex' ? (
        <FaCcAmex size={28} className="text-primary-300" />
      ) : (
        <TbCreditCard size={28} className="text-gray-600" />
      );
    return (
      <>
        <div className="flex h-10 w-10 items-center justify-center">{icon}</div>
        <div>
          <p className="font-medium text-primary-900">
            {t('card')} {t('endingIn')} {details.last4}
          </p>
          <p className="text-sm text-gray-500">
            {t('expiryDate')}: {details.exp_month}/{details.exp_year}
          </p>
        </div>
      </>
    );
  }

  if (details.type === 'sepa_debit') {
    return (
      <>
        <div className="flex h-10 w-10 items-center justify-center">
          <SiSepa size={28} className="text-primary-300" />
        </div>
        <div>
          <p className="font-medium text-primary-900">
            {details.name} - {details.bank_code} {t('endingIn')} {details.last4}
          </p>
        </div>
      </>
    );
  }

  // paypal
  return (
    <>
      <div className="flex h-10 w-10 items-center justify-center">
        <SiPaypal size={28} className="text-primary-300" />
      </div>
      <div>
        <p className="font-medium text-primary-900">
          {details.name && `${details.name}, `}
          {details.email}
        </p>
      </div>
    </>
  );
}
